/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { clipboardButtonOnClick, decklistContains } from '../store/clipboard'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import styles from '../styles/Card.module.scss'

const ClipboardButton = ({ cardProps, layout, name, names }) => {
  const dispatch = useDispatch()
  // eslint-disable-next-line no-unused-vars
  const clipboard = useSelector((state) => state.clipboard) // required to trigger renders

  const cardname =
    layout && ['modal_dfc', 'transform'].includes(layout) ? names[0] : name

  if (
    !cardname ||
    (layout === 'meld' && cardProps.name === cardProps.names[2]) // Hide button for meld backsides
  ) {
    return null
  }

  const decklistContainsCard = dispatch(decklistContains(cardname))

  return (
    <div
      className={styles.clipboardButtonOuter}
      onClick={() => dispatch(clipboardButtonOnClick(cardProps))}
    >
      <div
        className={classNames(styles.clipboardButton, {
          [styles.checkmark]: decklistContainsCard,
        })}
      >
        <FontAwesomeIcon
          className={styles.clipboardButtonIcon}
          icon={decklistContainsCard ? 'check' : 'plus'}
        />
      </div>
    </div>
  )
}

export default ClipboardButton
